import type { Transaction } from "./finance.ts";

/** Preserve array identity when pruning options does not change a selection. */
export function retainAvailableFilters(current: string[], available: ReadonlySet<string>) {
  const next = current.filter((value) => available.has(value));
  return next.length === current.length ? current : next;
}

/** Source links are not returned by a single-row write. Keep the existing links. */
export function mergeSavedTransaction(current: Transaction, saved: Transaction) {
  return { ...saved, sourceBatchIds: current.sourceBatchIds, sourceFiles: current.sourceFiles,
    sourceFile: current.sourceFile, sourceRowNumber: current.sourceRowNumber };
}
